import React from 'react';
import { WysiwygLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import QuillWysiwygLayout from '../../../form/input/layout/QuillWysiwygLayout';
import ShadcnQuillWysiwygLayout from '../../../form/input/layout/ShadcnQuillWysiwygLayout';

export default function WysiwygLayout(props: WysiwygLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnQuillWysiwygLayout {...props} />;
  } else {
    return <QuillWysiwygLayout {...props} />;
  }
}
